import React from "react";
import getStyled from "../../../../hooks/getStyled";
import { SFStack } from "../../../grid";
import { SFExpandMoreIcon, SFDragHandleIcon } from "../../../icons";
import SFTypography from "../../../typography";

const { styled } = getStyled();

const StyledStack = styled(SFStack)(({ theme }) => ({
  width: theme.spacing(36),
  height: theme.spacing(5),
  backgroundColor: theme.palette.blue100_1.main,
  padding: theme.spacing(1),
}));

const DragPreviewRenderer = ({ item }) => {
  return (
    <StyledStack direction="row" spacing={1.25} alignItems="center">
      {item.data.hasChild && <SFExpandMoreIcon color="grey350" />}
      <SFDragHandleIcon color="grey350" />
      <SFTypography variant="tableList" noWrap textEllipsis>
        {item.text}
      </SFTypography>
    </StyledStack>
  );
};

export default DragPreviewRenderer;
